import React, { useState } from 'react';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import './Navbar.css';

function Navbar({ isOpen4, onClose4, query }) {
  const [timeRange, setTimeRange] = useState('now 1-d'); // 기본값은 1일
  const handleCancelButtonClick = () => {
    onClose4();
  };

  const trendsUrl = `https://trends.google.com:443/trends/embed/explore/TIMESERIES?req=%7B%22comparisonItem%22%3A%5B%7B%22keyword%22%3A%22${encodeURIComponent(
    query,
  )}%22%2C%22geo%22%3A%22KR%22%2C%22time%22%3A%22${timeRange}%22%7D%5D%2C%22category%22%3A0%2C%22property%22%3A%22youtube%22%7D&tz=-540&eq=date%3D${timeRange}%26geo%3DKR%26gprop%3Dyoutube%26q%3D${encodeURIComponent(
    query,
  )}`;

  const relatedQueriesUrl = `https://trends.google.com:443/trends/embed/explore/RELATED_QUERIES?req=%7B%22comparisonItem%22%3A%5B%7B%22keyword%22%3A%22${encodeURIComponent(
    query,
  )}%22%2C%22geo%22%3A%22KR%22%2C%22time%22%3A%22${timeRange}%22%7D%5D%2C%22category%22%3A0%2C%22property%22%3A%22youtube%22%7D&tz=-540&eq=date%3D${timeRange}%26geo%3DKR%26gprop%3Dyoutube%26q%3D${encodeURIComponent(
    query,
  )}`;

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
  };

  return (
    <div className={`modal ${isOpen4 ? 'open' : ''}`}>
    <Iframe url={trendsUrl} width="100%" height="500px" frameBorder="0" scrolling="no" />
    <Iframe url={relatedQueriesUrl} width="100%" height="500px" frameBorder="0" scrolling="no" />
    <div className="button-container">
      <div className="time-range-buttons">
        <label>
          <input
            type="radio"
            name="timeRange"
            value="now 1-d"
            checked={timeRange === 'now 1-d'}
            onChange={handleTimeRangeChange}
          />
          1일
        </label>
        <label>
          <input
            type="radio"
            name="timeRange"
            value="now 7-d"
            checked={timeRange === 'now 7-d'}
            onChange={handleTimeRangeChange}
          />
          7일
        </label>
        <label>
          <input
            type="radio"
            name="timeRange"
            value="today 1-m"
            checked={timeRange === 'today 1-m'}
            onChange={handleTimeRangeChange}
          />
          30일
        </label>
        <label>
          <input
            type="radio"
            name="timeRange"
            value="today 3-m"
            checked={timeRange === 'today 3-m'}
            onChange={handleTimeRangeChange}
          />
          90일
        </label>
        <label>
          <input
            type="radio"
            name="timeRange"
            value="today 12-m"
            checked={timeRange === 'today 12-m'}
            onChange={handleTimeRangeChange}
          />
          1년
        </label>
      </div>
      <button onClick={handleCancelButtonClick}>닫기</button>
    </div>
  </div>
  );
}

Navbar.propTypes = {
  isOpen4: PropTypes.bool.isRequired,
  onClose4: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
};

export default Navbar;
